import React, { useMemo } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { FormField } from "./FormField";

/**
 * Pick a pending stack sample line, optionally filtered by party.
 */
export function StackSampleLineSelect({
  lines,
  partyId,
  value,
  onChange,
  label = "Sample ID",
  required,
  disabled,
  testId = "stack-sample-select",
}) {
  const filtered = useMemo(() => {
    if (!partyId) return [];
    return lines.filter((ln) => String(ln.party_id) === String(partyId));
  }, [lines, partyId]);

  const placeholder = !partyId
    ? "Select party first…"
    : filtered.length === 0
      ? "No pending samples for this party"
      : "Select sample ID…";

  return (
    <FormField
      label={label}
      required={required}
      hint={partyId ? `${filtered.length} pending sample(s) for selected party` : "Choose party to narrow the list"}
      className="md:col-span-2"
    >
      <Select
        value={value || "_none"}
        onValueChange={(v) => onChange(v === "_none" ? "" : v)}
        disabled={disabled || !partyId || filtered.length === 0}
      >
        <SelectTrigger data-testid={testId}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="_none" disabled>
            {placeholder}
          </SelectItem>
          {filtered.map((line) => (
            <SelectItem key={line.id} value={String(line.id)}>
              <span className="font-mono text-xs">{line.sample_code}</span>
              {" — "}Stack {line.stack_number} ({line.quality})
              {line.intake_code ? ` · ${line.intake_code}` : ""}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </FormField>
  );
}
